import clsx from 'clsx'
import Drawer from 'components/Drawer'
import PropTypes from 'prop-types'
import React from 'react'
import styles from 'components/UI/with-drawer.module.scss'

const WithDrawer = ({
  drawerClassName = '',
  contentClassName = '',
  drawerChildren = null,
  extraNavigation = null,
  content,
  children,
}) => (
  <>
    <Drawer className={drawerClassName}>
      <div>
        {extraNavigation}
        {drawerChildren}
      </div>
    </Drawer>
    <div className={clsx(styles['content'], contentClassName)}>
      {content ? content : children}
    </div>
  </>
)

WithDrawer.propTypes = {
  drawerRef: PropTypes.object,
  drawerClassName: PropTypes.string,
  contentClassName: PropTypes.string,
  drawerChildren: PropTypes.element,
  content: PropTypes.element,
  extraNavigation: PropTypes.oneOfType([
    PropTypes.oneOf([null]),
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element),
  ]),
  children: PropTypes.oneOfType([
    PropTypes.oneOf([null]),
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element),
  ]),
}

export default WithDrawer
